import React from 'react';
import config from '../config/config';

/**
 * Environment Indicator Component
 * 
 * This component displays the current environment based on the URL.
 * It's only shown in development mode.
 */
const EnvSwitcher = () => {
  const isLocalhost = config.isLocalhost();
  const environment = config.getEnvironment();
  const apiUrl = config.getApiBaseUrl();
  
  return (
    <div className="fixed bottom-4 right-4 bg-white p-3 rounded-lg shadow-lg border border-gray-200">
      <div className="flex items-center space-x-2">
        <span className="text-sm font-medium">
          Environment: 
          <span className={`ml-1 px-2 py-1 rounded text-xs ${
            isLocalhost ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'
          }`}>
            {environment}
          </span>
        </span>
      </div>
      <div className="mt-1 text-xs text-gray-500">
        API: {apiUrl}
      </div>
    </div>
  );
};

export default EnvSwitcher; 